<!-- Withdraw Ticket Modal -->
<div
  class="modal fade"
  [class.show]="isOpen()"
  [style.display]="isOpen() ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <div class="d-flex align-items-center">
          <i class="bi bi-x-circle text-warning fs-4 me-2"></i>
          <h5 class="modal-title mb-0">Withdraw Ticket</h5>
        </div>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
          [disabled]="isProcessing()"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <p class="text-muted mb-3">
          You are about to withdraw ticket <strong>{{ ticketNumber }}</strong>.
          This will close the ticket and notify support. Please select a reason:
        </p>

        <!-- Reason Selection -->
        <div class="reason-list">
          <div
            *ngFor="let reason of reasons"
            class="form-check reason-item p-3 mb-2 rounded"
            [class.selected]="selectedReason === reason.value"
            (click)="selectedReason = reason.value"
          >
            <input
              class="form-check-input"
              type="radio"
              [id]="'reason-' + reason.value"
              name="withdrawReason"
              [value]="reason.value"
              [(ngModel)]="selectedReason"
            />
            <label class="form-check-label d-block ms-2" [for]="'reason-' + reason.value">
              <span class="fw-medium">{{ reason.label }}</span>
              <small class="d-block text-muted">{{ reason.description }}</small>
            </label>
          </div>
        </div>

        <!-- Other Details (shown when 'other' is selected) -->
        <div *ngIf="selectedReason === 'other'" class="mt-3">
          <label for="otherDetails" class="form-label">Please provide details:</label>
          <textarea appCharCounter
            id="otherDetails"
            class="form-control"
            rows="3"
            [(ngModel)]="otherDetails"
            placeholder="Explain why you're withdrawing this ticket..."
            [disabled]="isProcessing()"
          ></textarea>
        </div>

        <!-- Info Notice -->
        <div class="alert alert-info mt-3 mb-0 d-flex align-items-start">
          <i class="bi bi-info-circle me-2 mt-1"></i>
          <small>
            Withdrawing a ticket closes it and records the reason. Your support team
            will be notified and can still view the ticket history if needed.
          </small>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="close()"
          [disabled]="isProcessing()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-warning"
          (click)="confirm()"
          [disabled]="!canConfirm || isProcessing()"
        >
          <span *ngIf="isProcessing()" class="spinner-border spinner-border-sm me-1"></span>
          {{ isProcessing() ? 'Withdrawing...' : 'Withdraw Ticket' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div *ngIf="isOpen()" class="modal-backdrop fade show"></div>
